/* bio-sticky-atc — muestra la barra fija solo cuando el formulario de compra
   original salió del viewport por ARRIBA (es decir, el usuario ya scrolleó
   más allá del CTA). Vanilla, deferido, sin librerías.
   Kill-switch: setting "bio_sticky_atc" del section main-product. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-bio-sticky-atc]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var form = document.getElementById(bar.getAttribute('data-form-id'));
  if (!form) return;
  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[entries.length - 1];
    var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('bio-sticky-atc--visible', scrolledPast);
  });
  observer.observe(form);
})();
